if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this._variantIdInput = this.form.querySelector('[name=id]');
        if (this._variantIdInput) {
          this._variantIdInput.disabled = false;
          // this._variantIdInput.removeAttribute('name');
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        // this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButtonText =
          this.submitButton.querySelector('span') ||
          this.submitButton.querySelector('.product-card__quick-add-text') ||
          null;

        this.productIdInput = this.form.querySelector('[name="product-id"]');
        this.productId = this.productIdInput ? String(this.productIdInput.value) : '';

        this.addToCartText = this.dataset.addToCartText || window.variantStrings?.addToCart || 'Add to cart';
        this.soldOutText = this.dataset.soldOutText || window.variantStrings?.soldOut || 'Sold out';

        this.productUpgrades = this.dataset.productUpgrades;
        this.baseVariantPrice = 0;
        const initialPriceEl = this.querySelector('.bb-price-item');
        if (initialPriceEl) {
          this.baseVariantPrice = Number(initialPriceEl.dataset.basePrice || 0);
        }

        document.addEventListener('variant:changed', (evt) => {
          const { variant, productId } = evt.detail || {};
          if (!variant) return;

          if (this.productId && String(productId) !== String(this.productId)) return;

          if (this.variantIdInput) this.variantIdInput.value = variant.id;

          const isSoldOut = variant.available === false;

          if (isSoldOut) {
            this.toggleSubmitButton(true, this.soldOutText);
          } else {
            this.toggleSubmitButton(false, this.addToCartText);
          }

          // Update total price when variant changes (only if upgrades are active)
          const fullPrice = Number(variant.shopify_price || variant.price || 0);
          this.baseVariantPrice = this.getPromoBaseCents(isNaN(fullPrice) ? 0 : fullPrice);

          if (this.productUpgrades) {
            this.querySelectorAll('.bb-price-item').forEach(el => {
              el.dataset.basePrice = this.baseVariantPrice;
            });
            this.updateTotalButtonPrice();
          }
        });

        // Listen for upgrades toggles
        if (this.productUpgrades) {
          document.addEventListener('change', (e) => {
            if (e.target?.classList?.contains('product-upgrades__item-id')) {
              this.updateTotalButtonPrice();
            }
          });
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.updateTotalButtonPrice();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        const props = {};
        const baseFormData = new FormData(this.form);

        for (const [k, v] of baseFormData.entries()) {
          const m = String(k).match(/^properties\[(.+)\]$/);
          if (m) props[m[1]] = v;
        }

        for (const entry of baseFormData.entries()) {
          const key = entry[0];
          const value = entry[1];
          const keyAsString = String(key);
          const match = keyAsString.match(/^properties\[(.+)\]$/);

          if (match !== null) {
            const propertyName = match[1];

            props[propertyName] = value;
          }
        }

        let index = 0;

        if (this.productUpgrades) {
          const additionalProducts = [...document.querySelectorAll('.product-upgrades__item-id:checked')];
          additionalProducts.forEach((checkbox) => {
            const id = checkbox.value;
            const quantity = 1;
            formData.append(`items[${index}][id]`, id);
            formData.append(`items[${index}][quantity]`, quantity);
            index++;
          });
        }

        const mainId = this.variantIdInput?.value;
        const quantity = this.form.querySelector('[name="quantity"]')?.value || 1;

        if (mainId) {
          formData.append(`items[${index}][id]`, mainId);
          formData.append(`items[${index}][quantity]`, quantity);

          Object.entries(props).forEach(([key, val]) => {
            formData.append(`items[${index}][properties][${key}]`, val);
          });

          if (props._is_preorder) {
            formData.append(`items[${index}][properties][Preorder]`, '✓');
          }
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainId,
                cartData: response,
              });

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            document.dispatchEvent(
              new CustomEvent('cart:added', {
                detail: {
                  item: {
                    id: Number(mainId),
                  },
                  cart: response,
                },
              })
            );
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');

          if (this.submitButtonText) {
            this.submitButtonText.textContent = text || window.variantStrings.addToCart;
          }
        }
      }

      updateTotalButtonPrice() {
        if (!this.productUpgrades) return;
        const upgradesTotal = this.getSelectedUpgradesTotal();
        let priceEls = this.querySelectorAll('.bb-price-item');

        // If the price element is missing (e.g. wiped by a third-party app like Globo Preorder)
        // we try to find the button and re-inject it.
        if (priceEls.length === 0) {
          const mainButton = this.querySelector('.product-form__submit') || this.querySelector('button[type="submit"]');
          if (mainButton) {
            const span = document.createElement('span');
            span.className = 'bb-price-item';
            span.dataset.basePrice = this.baseVariantPrice;
            mainButton.appendChild(span);
            priceEls = [span];
          }
        }

        priceEls.forEach(el => {
          const base = Number(el.dataset.basePrice || this.baseVariantPrice || 0);
          const total = base + upgradesTotal;
          el.textContent = this.formatMoney(total);
        });
      }

      getSelectedUpgradesTotal() {
        if (!this.productUpgrades) return 0;

        const checked = [...document.querySelectorAll('.product-upgrades__item-id:checked')];

        return checked.reduce((sum, el) => {
          const p = Number(el.dataset.upgradePrice || 0);
          return sum + (isNaN(p) ? 0 : p);
        }, 0);
      }

      getPromoBaseCents(fullCents) {
        const promo = window.theme?.promoPricing;
        const percent = Number(promo?.percent || 0);
        if (promo?.enabled && percent > 0 && fullCents > 0) {
          return Math.floor((fullCents * (100 - percent)) / 100);
        }
        return fullCents;
      }

      formatMoney(cents) {
        // Works in most Shopify themes
        if (window.Shopify?.formatMoney) {
          const format = window.theme?.moneyFormat || window.Shopify?.money_format || "{{amount}}";
          return window.Shopify.formatMoney(cents, format);
        }

        // Fallback: simple “cents -> dollars” (won’t match your locale perfectly)
        return (cents / 100).toFixed(2);
      }

      // Optional fallback if you want to parse initial formatted text.
      // This is best-effort only; data attributes are more reliable.
      parseMoneyFromText(txt) {
        if (!txt) return 0;
        const num = Number(String(txt).replace(/[^0-9.,]/g, '').replace(',', '.'));
        if (isNaN(num)) return 0;
        return Math.round(num * 100);
      }


      get variantIdInput() {
        return this._variantIdInput;
      }

      getBbPriceEl() {
        return this.querySelector('.bb-price-item');
      }
    }
  );
}
